import { useEffect, useRef } from 'react';

/**
 * Custom hook that auto-scrolls a container to the bottom
 * whenever any of the provided dependencies change.
 */
export function useAutoScroll(deps = []) {
  const endRef = useRef(null);

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: 'smooth' });
  });

  return endRef;
}
